import { render } from "./KnowledgeEditor.vue?vue&type=template&id=530bfb3e&scoped=true"
import script from "./KnowledgeEditor.vue?vue&type=script&lang=js"
export * from "./KnowledgeEditor.vue?vue&type=script&lang=js"

import "./KnowledgeEditor.vue?vue&type=style&index=0&id=530bfb3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530bfb3e"]])

export default __exports__